module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigDiv"
  }, [_c('div', {
    staticClass: "bgDiv"
  }), _vm._v(" "), _c('div', {
    staticClass: "bgImg"
  }, [_c('img', {
    attrs: {
      "src": require('../../../assets/images/Group 540@2x.png')
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac6cd11"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cardCoupons/component/couponDownload.vue
// module id = 465
// module chunks = 1